import { FC } from 'react';

import { Skeleton } from 'ui/skeleton';

import { ContentDivider, ColumnTextBlock, SkeletonRow } from './CampaignSkeleton.styles';

export const CAMPAIGN_SKELETON_ID = 'nba-campaign-skeleton';

export const CampaignSkeleton: FC = () => {
  return (
    <div data-test={CAMPAIGN_SKELETON_ID}>
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={200} />
          <Skeleton height={16} width={150} />
        </ColumnTextBlock>
      </SkeletonRow>
      <ContentDivider />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={200} />
          <Skeleton height={16} width={150} />
        </ColumnTextBlock>
      </SkeletonRow>
      <ContentDivider />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={200} />
          <Skeleton height={16} width={150} />
        </ColumnTextBlock>
      </SkeletonRow>
    </div>
  );
};
